export default function Binary_tree() {
  return (
    <>
      <div class="row_binary">
        <div class="column_binary">
          <div class="container_float">
            <h2>Cash management software :</h2>
            <br />
            <p className="binary_content">
              {" "}
              The goal of this project is to create a cash management software
              for an association, using double-entry accounting principles.
              <br />
              <br />
              This project has been done using C++.
            </p>
          </div>
        </div>
        <div class="column_binary">
          <div class="container_float">
            <h2>Links :</h2>
            <br />
            <h3>
              Project code and explaination :{" "}
              <a href="https://gitlab.utc.fr/hlecourt/projet-tresorerie-lo21">
                Project repository
              </a>
            </h3>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
